import React, { Dispatch, SetStateAction } from "react";
import { Link, NavigateFunction } from "react-router-dom";
import { languageType } from "../../../interface/redux/config";

type Props = {
  Nav_layout: string[];
  Open_Nav_layout: {
    title: string;
    list: { title: string; link: string }[];
  }[];
  navigate: NavigateFunction;
  setIsHover: Dispatch<SetStateAction<boolean>>;
  isHover: boolean;
  language: languageType;
  ChangeLanguage: () => void;
  pathname: string;
};

const DeskHeader = ({
  Nav_layout,
  Open_Nav_layout,
  navigate,
  setIsHover,
  isHover,
  language,
  ChangeLanguage,
  pathname,
}: Props) => {
  return (
    <>
      <header className="fixed top-0 left-0 z-50 flex items-center justify-between w-full h-16 bg-black px-4 lg:px-6 xl:px-14">
        <div className="flex items-center gap-x-4 lg:gap-x-6 xl:gap-x-14">
          <Link className="w-[180px] shrink-0" to={"/"}>
            <img
              src="/assets/brand/huconn-white.svg"
              className="w-full h-auto"
              width={1740}
              height={362}
              alt="HUCONN"
            />
          </Link>
          <div className="flex cursor-pointer gap-x-4 lg:gap-x-7">
            {Nav_layout.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="flex items-center font-bold text-white gap-x-1"
                  onClick={() => {
                    if (idx !== 4) {
                      setIsHover(!isHover);
                    } else {
                      navigate("/contact");
                    }
                  }}
                >
                  {item}
                  {idx !== 4 ? (
                    <div className="w-4">
                      <img src="/assets/header/arrow.svg" alt="" />
                    </div>
                  ) : undefined}
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex items-center gap-x-1 text-sm font-bold">
          <button
            className={`px-2 py-1 rounded transition-all ${language === "kr" ? "text-white" : "text-gray200 hover:text-white"}`}
            onClick={() => { if (language !== "kr") ChangeLanguage(); }}
          >
            KO
          </button>
          <span className="text-gray200">|</span>
          <button
            className={`px-2 py-1 rounded transition-all ${language === "eng" ? "text-white" : "text-gray200 hover:text-white"}`}
            onClick={() => { if (language !== "eng") ChangeLanguage(); }}
          >
            EN
          </button>
        </div>
      </header>
      <div
        className={`fixed left-0 z-40 flex gap-x-11 bg-black h-64 w-full transition-all duration-300 ease-in-out pl-60 pt-top18 ${
          isHover ? "top-16" : "top-[-300px]"
        }`}
      >
        {Open_Nav_layout.map(({ title, list }, idx) => {
          return (
            <div key={idx} className="flex flex-col gap-y-4">
              <div className="text-base font-bold bg-main w-fit">{title}</div>
              {list.map(({ title, link }, idx) => {
                return (
                  <Link
                    key={idx}
                    to={link}
                    className={`font-bold text-sm ${
                      link === pathname ? "text-blue" : "text-white"
                    }`}
                  >
                    {title}
                  </Link>
                );
              })}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DeskHeader;
